import { createFileRoute } from "@tanstack/react-router";
import { AdminActionsPage } from "@/components/admin/actions/AdminActionsPage";

export const Route = createFileRoute("/$workspaceSlug/admin/actions")({
  component: AdminActionsPage,
});
